import { useCallback, useState } from 'react';

import useGetEmployeeSSNQuery from '@/modules/employee/Employee/PersonalInformation/EmployerInfo/queries/useGetEmployeeSSN.query';

import { HSACombineAccount } from '../types/combineHSA.types';

interface Params {
  employeeId: string;
  onSetVisible: (value: boolean) => void;
}

export const useCombineHSAModal = ({ employeeId, onSetVisible }: Params) => {
  const [selectedFromId, setSelectedFromId] = useState<string | null>(null);
  const [selectedToId, setSelectedToId] = useState<string | null>(null);
  const [selectedFromAccount, setSelectedFromAccount] = useState<HSACombineAccount | null>(null);
  const [selectedToAccount, setSelectedToAccount] = useState<HSACombineAccount | null>(null);
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  const { ssn } = useGetEmployeeSSNQuery(employeeId);

  const handleClose = useCallback((value: boolean) => {
    if (!value) {
      setSelectedFromId(null);
      setSelectedToId(null);
      setSelectedFromAccount(null);
      setSelectedToAccount(null);
      setIsSubmitAttempted(false);
    }
    onSetVisible(value);
  }, [onSetVisible]);

  const handleCancel = useCallback(() => handleClose(false), [handleClose]);

  const handleNext = useCallback(() => {
    setIsSubmitAttempted(true);
  }, []);

  const handleSelectFrom = useCallback((account: HSACombineAccount) => {
    setSelectedFromId(account.accountId);
    setSelectedFromAccount(account);
  }, []);

  const handleSelectTo = useCallback((account: HSACombineAccount) => {
    setSelectedToId(account.accountId);
    setSelectedToAccount(account);
  }, []);

  const handleClearSelection = useCallback(() => {
    setSelectedFromId(null);
    setSelectedToId(null);
    setSelectedFromAccount(null);
    setSelectedToAccount(null);
  }, []);

  return {
    ssn,
    selectedFromId,
    selectedToId,
    selectedFromAccount,
    selectedToAccount,
    isSubmitAttempted,
    handleClose,
    handleCancel,
    handleNext,
    handleSelectFrom,
    handleSelectTo,
    handleClearSelection,
  };
};
